import type { FallbackImageSizes } from 'atoms/FallbackImage/FallbackImage.h'
import type { IconQualitySizes, IconSocialSizes } from './Icon.h'

import { styled } from '@linaria/react'
import { IconSizes } from './Icon.h'

export const IconSC = styled.svg<{
  size:
    | IconSizes
    | FallbackImageSizes
    | IconSocialSizes
    | IconQualitySizes
    | null
  iconHeight?: IconSizes | null
  colorDefault?: string
}>`
  font-size: ${({ size }) => (size ? size : IconSizes.medium)};
  height: ${({ iconHeight }) => (iconHeight ? iconHeight : '1em')};
  width: 1em;
  vertical-align: middle;
  flex-shrink: 0;
  color: ${({ colorDefault }) => `var(${colorDefault})`};
`
